import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Cultura } from 'src/app/classes/Cultura';
import { GrupoProduto } from 'src/app/classes/GrupoProduto';
import { GrupoProdutoCulturaCentroCusto } from 'src/app/classes/GrupoProdutoCulturaCentroCusto';
import { GrupoProdutoService } from 'src/app/services/grupo-produto.service';
import { StorageService } from 'src/app/services/storage.service';
import { CustomToastyService } from 'src/app/theme/shared/components/toasty/custom-toasty.service';
import { UtilsService } from 'src/app/utils/utils.service';
import { NgForm, NgModel } from '@angular/forms';
import { UiModalComponent } from 'src/app/theme/shared/components/modal/ui-modal/ui-modal.component';

@Component({
  selector: 'app-grupo-produto-forms',
  templateUrl: './grupo-produto-forms.component.html',
  styleUrls: ['./grupo-produto-forms.component.scss']
})
export class GrupoProdutoFormsComponent implements OnInit {

  @ViewChild('Modal', { static: false }) modal: UiModalComponent
  @ViewChild('formulario', { static: false }) formulario!: NgForm;
  @Output() finalizarSave: EventEmitter<void> = new EventEmitter()
  @Input() IsServico: boolean = false
  @Input() culturas: Cultura[] = []
  @Input() integraTotvs: boolean = false

  isSubmit: boolean = false
  grupoProduto: GrupoProduto = new GrupoProduto()
  carregando: boolean = false
  servicos: boolean = false

  listaGrupoProdutoCulturaCentroCusto: GrupoProdutoCulturaCentroCusto[] = [];


  constructor(
    private gruposProdutoService: GrupoProdutoService,
    private utils: UtilsService,
    private translate: TranslateService,
    private storageService: StorageService,
    private toasty: CustomToastyService
  ) {}

  ngOnInit() {
    this.servicos = this.IsServico;
  }

  abrirModal(grupoProduto: GrupoProduto = null): void {
    if(grupoProduto == null && !this.utils.verificarPermissaoUsuario('IncluirGrupoProduto'))
      return;
    if (grupoProduto != null){
      if(!this.utils.verificarPermissaoUsuario('EditarGrupoProduto'))
        return;
      this.grupoProduto = grupoProduto;
    }
    else {
      this.grupoProduto = new GrupoProduto();
      this.listaGrupoProdutoCulturaCentroCusto = [];
    }
   if(this.grupoProduto.Id != null && this.grupoProduto.Id > 0)
    {
      this.gruposProdutoService.getGrupoProduto(this.grupoProduto.Id).subscribe(res => {
        this.listaGrupoProdutoCulturaCentroCusto = res.listaGruposCusto || [];
      });
    }
    this.modal.show()
  }

  fecharModal(): void {
    this.modal.hide()
    this.isSubmit = false
    this.formulario.resetForm();
    
  }

  isCampoInvalido(campo: NgModel): boolean {
    return (
      !campo.valid &&
      (campo.dirty || campo.touched || this.isSubmit)
    );
  }


  save(): void {
    this.carregando = true

    if (!this.validarForm()) return

    if (this.listaGrupoProdutoCulturaCentroCusto.length > 0) {
      this.grupoProduto.listaGrupoProdutoCulturaCentroCusto = this.listaGrupoProdutoCulturaCentroCusto;
    }
    if (this.servicos) {
      this.grupoProduto.Servico = true;
    }
    else {
      this.grupoProduto.Servico = false;
    }

    this.grupoProduto.UsuarioAlteracao = null;
    this.grupoProduto.UsuarioCadastro = null;

    if (this.grupoProduto.Id) {
      this.gruposProdutoService
        .putGrupoProduto(this.grupoProduto.Id, this.grupoProduto)
        .subscribe(
          (res) => {
            this.finalizarSaveRequestSuccess(
              this.servicos ? 'Grupo de Serviço alterado com sucesso!' : 'Grupo de Produto alterado com sucesso!',
            )
          },
          (err) => {
            this.finalizarRequestError(err)
          },
        )
    } else {
      this.gruposProdutoService.postGrupoProduto(this.grupoProduto).subscribe(
        (res) => {
          this.finalizarSaveRequestSuccess(
            this.servicos ? 'Grupo de Serviço cadastrado com sucesso!' : 'Grupo de Produto cadastrado com sucesso!',
          )
        },
        (err) => {
          this.finalizarRequestError(err)
        },
      )
    }
  }

  validarForm(): boolean {
    if (this.formulario.invalid) {
      this.isSubmit = true
      this.carregando = false
      this.utils.handleWarning(
        'Por favor, preencha todos os campos obrigatórios corretamente.',
      )
      return false
    }

    return true
  }

  finalizarSaveRequestSuccess(msg: string): void {
    this.utils.handleSuccess(msg)
    this.carregando = false
    this.finalizarSave.emit()
    this.fecharModal()
  }

  finalizarRequestError(error: any): void {
    this.utils.getErro(error)
    this.carregando = false
  }

  novoItemCCusto() {
    let itemCCusto: GrupoProdutoCulturaCentroCusto = new GrupoProdutoCulturaCentroCusto;
    this.listaGrupoProdutoCulturaCentroCusto.push(itemCCusto);
  }

  onCulturaChange(item: GrupoProdutoCulturaCentroCusto) {
    // Quando limpar a seleção, atribui 0 ao invés de null/undefined
    if (item.CulturaId === null || item.CulturaId === undefined) {
      item.CulturaId = 0;
    }
  }

  onCulturaClear(item: GrupoProdutoCulturaCentroCusto) {
    // Quando o usuário clica no X para limpar, força o valor para 0
    item.CulturaId = 0;
  }

}
